import { applyMiddleware, compose, createStore, Store, StoreEnhancer, StoreEnhancerStoreCreator } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware, { SagaIterator } from 'redux-saga';
import { customMiddleware } from 'router';
import { readOnlyCampaignMiddleware } from 'sections/campaigns/state/splitTests/readOnlyCampaignMiddleware';
import { startApplication } from './actions';
import routerHistory from './history';
import connectedRouterMiddleware from './middleware';
import { reducer, State } from './reducer';
import Sagas from './sagas';

// Create the store
export const initStore = (initialState: State = undefined, sagas: (() => SagaIterator)[] = Sagas): Store<State> => {
  // Middleware
  const sagaMiddleware = createSagaMiddleware();
  const middleware = [readOnlyCampaignMiddleware, customMiddleware, connectedRouterMiddleware];
  if (sagas.length > 0) {
    middleware.push(sagaMiddleware);
  }

  const devTools = [];
  if (import.meta.env.DEV) {
    const devToolsExtension = (window as any).devToolsExtension;
    if (typeof devToolsExtension === 'function') {
      devTools.push(devToolsExtension());
    }
    middleware.push(
      createLogger({
        collapsed: true,
        // Custom formatter to show the service in the title of the logger output
        titleFormatter: (action: any, time: any, took: any) =>
          `action @ ${time} ${action.service || ''} ${action.type} (in ${took.toFixed(2)} ms)`,
      }),
    );
  }

  const composedMiddleware: StoreEnhancer<any> = compose<StoreEnhancerStoreCreator<any>>(
    applyMiddleware(...middleware),
    ...devTools,
  );
  const store = createStore(reducer(routerHistory), initialState, composedMiddleware);

  sagas.forEach(saga => sagaMiddleware.run(saga));

  // Dispatch an application start action for listeners.
  store.dispatch(startApplication());

  return store;
};
